import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import Footer from '../components/Footer';
import { useContent } from '../contexts/ContentContext';
import './Home.css';

const Home = () => {
  const { i18n } = useTranslation();
  const { content } = useContent();
  const isSk = i18n.language?.startsWith('sk');
  const lang = isSk ? 'Sk' : 'En';
  const a = content.about;

  return (
    <>
      <Helmet>
        <html lang={isSk ? 'sk' : 'en'} />
        <title>
          {isSk
            ? 'ZEL s.r.o. | Multi-Brand Foodservice spoločnosť'
            : 'ZEL s.r.o. | Multi-Brand Foodservice Company'}
        </title>
        <meta
          name="description"
          content={isSk
            ? 'ZEL je multi-brand foodservice spoločnosť pôsobiaca v reštauračných, fast-food a kávových konceptoch.'
            : 'ZEL is a multi-brand foodservice company operating across restaurant, fast-food, and coffee concepts.'}
        />
      </Helmet>

      <Navbar />

      <main>
        <Hero />

        {/* About Our Company — gallery + text matching zel.sk */}
        <section className="home-about" id="about">
          <div className="container">
            <h2 className="home-about__title">
              {isSk ? 'O NAŠEJ SPOLOČNOSTI' : 'ABOUT OUR COMPANY'}
            </h2>
            <div className="home-about__gallery">
              <div className="home-about__img">
                <img
                  src={a.images?.[0] || 'https://images.unsplash.com/photo-1556761175-5973dc0f32e7?w=900&q=80'}
                  alt=""
                  loading="lazy"
                />
              </div>
              <div className="home-about__img">
                <img
                  src={a.images?.[1] || 'https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=900&q=80'}
                  alt=""
                  loading="lazy"
                />
              </div>
            </div>
            <div className="home-about__inner">
              <p>{a[`body${lang}`]}</p>
              <Link to="/about" className="btn home-about__btn">
                {isSk ? 'ZISTIŤ VIAC' : 'LEARN MORE'}
              </Link>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
};

export default Home;
